import { Theme } from "@material-ui/core/styles";

export type SidePadding = { paddingLeft: number; paddingRight: number };

export const responsiveSidePadding = (theme: Theme, additionalPadding = 0): { [cssMediaQuery: string]: SidePadding } => ({
    [theme.breakpoints.only("xs")]: sidePadding(8 + additionalPadding),
    [theme.breakpoints.only("sm")]: sidePadding(16 + additionalPadding),
    [theme.breakpoints.only("md")]: sidePadding(24 + additionalPadding),
    [theme.breakpoints.only("lg")]: sidePadding(32 + additionalPadding),
    [theme.breakpoints.up("xl")]: sidePadding(56 + additionalPadding),
});

const sidePadding = (amount: number): SidePadding => ({ paddingLeft: amount, paddingRight: amount });
